import React from "react";
import { BibleVerse, BibleVersion } from "../types";

interface VerseComparisonProps {
  verses: Array<{
    version: BibleVersion;
    verse: BibleVerse;
  }>;
  bookName: string;
  chapterNumber: number;
  verseNumber?: number;
}

export default function VerseComparison({
  verses,
  bookName,
  chapterNumber,
  verseNumber,
}: VerseComparisonProps) {
  if (verses.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500 dark:text-gray-400">
        No verses to compare
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
          {bookName} {chapterNumber}
          {verseNumber ? `:${verseNumber}` : ""}
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {verses.map((item, index) => (
          <div
            key={`${item.version.id}-${item.verse.verse_index}`}
            className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4 shadow-sm"
          >
            <div className="mb-2">
              <h4 className="font-semibold text-gray-900 dark:text-white">
                {item.version.name}
                {item.version.abbreviation && (
                  <span className="ml-2 text-sm text-gray-500 dark:text-gray-400">
                    ({item.version.abbreviation})
                  </span>
                )}
              </h4>
              <p className="text-xs text-gray-500 dark:text-gray-400">
                {item.version.language}
              </p>
            </div>
            <div className="mt-3">
              <p className="text-sm font-medium text-gray-600 dark:text-gray-300 mb-1">
                {item.verse.reference_verses_csv}
              </p>
              <p className="text-gray-800 dark:text-gray-200 leading-relaxed">
                {item.verse.text}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

